import React, { useState } from "react";

type DateCalculatorProps = {
  visible: boolean;
  onHide: () => void;
};

const DateCalculator: React.FC<DateCalculatorProps> = ({ visible, onHide }) => {
  const [expiryDate, setExpiryDate] = useState<string>("");
  const [duration, setDuration] = useState<number | "">("");
  const [entryDate, setEntryDate] = useState<string | null>(null);
  const [remainingDays, setRemainingDays] = useState<number | null>(null);

  const calculateEntryDate = () => {
    if (!expiryDate || !duration) {
      alert("Please enter both expiry date and duration");
      return;
    }

    const expiry = new Date(expiryDate);
    const entry = new Date(expiry);
    entry.setDate(expiry.getDate() - Number(duration));
    const formattedEntry = entry.toISOString().split("T")[0];
    setEntryDate(formattedEntry);

    calculateRemainingDays();
  };

  const calculateRemainingDays = () => {
    if (!expiryDate) return;

    const today = new Date();
    const expiry = new Date(expiryDate);
    const diffTime = expiry.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    setRemainingDays(diffDays);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "rgba(0,0,0,0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onHide}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: "white",
          borderRadius: 8,
          minWidth: 340,
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          overflow: "hidden",
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            backgroundColor: "#cf1682ff",
            color: "white",
            padding: "12px 20px",
            fontSize: "1.25rem",
            fontWeight: "600",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span>Date Calculator</span>
          <button
            onClick={onHide}
            style={{
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "1.5rem",
              cursor: "pointer",
              lineHeight: "1",
            }}
            aria-label="Close modal"
          >
            &times;
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ padding: 20 }}>
          <label>
            Expiry Date: <br />
            <input
              type="date"
              placeholder="YYYY-MM-DD"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              style={{
                border: "1px solid #ccc",
                borderRadius: 4,
                padding: "6px 8px",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </label>

          <br /><br />
          <label>
            Allowed Duration (days): <br />
            <input
              type="number"
              min={0}
              value={duration}
              onChange={(e) =>
                setDuration(e.target.value === "" ? "" : Number(e.target.value))
              }
              style={{
                border: "1px solid #ccc",
                borderRadius: 4,
                padding: "6px 8px",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
          </label>

          {/* Buttons Row */}
          <div style={{ display: "flex", gap: "10px", marginTop: 16 }}>
            <button
              onClick={calculateEntryDate}
              style={{
                backgroundColor: "#be4297",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: 4,
                cursor: "pointer",
                flex: 1,
                fontWeight: 600,
                fontSize: "1rem",
              }}
            >
              Calculate Entry Date
            </button>

            <button
              onClick={onHide}
              style={{
                backgroundColor: "#E5E7EB",
                border: "none",
                padding: "8px 16px",
                borderRadius: 4,
                cursor: "pointer",
                flex: 1,
                fontWeight: 500,
              }}
            >
              Close
            </button>
          </div>

          {/* Results */}
          {entryDate && (
            <p style={{ marginTop: 12 }}>
              Entry Date: <strong>{entryDate}</strong>
            </p>
          )}
          {remainingDays !== null && (
            <p style={{ marginTop: 6 }}>
              Remaining Days:{" "}
              <strong style={{ color: remainingDays < 0 ? "red" : "green" }}>
                {remainingDays} day{remainingDays !== 1 ? "s" : ""}
              </strong>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DateCalculator;
